function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _instanceof(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import React from "react";
import FormSection, { isFormSectionChild } from "./FormSection";
import { injectTestId } from "@cvent/nucleus-test-automation";
import { isFunction } from "../../utils/is";
var isDivOnSubmit = function(props, onSubmit) {
    return props.element === 'div' && isFunction(onSubmit);
};
var _Component;
export var Form = function(_superClass) {
    "use strict";
    _inherits(Form, _superClass);
    var _super = _createSuper(Form);
    function Form() {
        _classCallCheck(this, Form);
        var _this;
        _this = _super.apply(this, arguments);
        _this.watchEnterClick = function(event) {
            var ref;
            var key = event.key, target = event.target, currentTarget = event.currentTarget;
            var onSubmit = _this.props.onSubmit;
            var submitButton = currentTarget.querySelector('input[type="submit"], button[type="submit"]');
            var implicitSubmissionInputCount = currentTarget.querySelectorAll('input:not([type]),input[type="text"],input[type="search"],input[type="url"],input[type="tel"],input[type="email"],input[type="password"],input[type="datetime-local"],input[type="date"],input[type="month"],input[type="week"],input[type="time"],input[type="number"]').length;
            if (isDivOnSubmit(_this.props, onSubmit) && key === 'Enter' && _instanceof(target, Element) && target.tagName.toLowerCase() === 'input' && (submitButton || implicitSubmissionInputCount <= 1) && !(submitButton === null || submitButton === void 0 ? void 0 : submitButton.getAttribute('disabled')) && (!target.getAttribute('type') || ((ref = target.getAttribute('type')) === null || ref === void 0 ? void 0 : ref.toLowerCase()) !== 'submit')) {
                onSubmit(event);
            }
        };
        _this.watchSubmitClick = function(event) {
            var target = event.target;
            var onSubmit = _this.props.onSubmit;
            if (isDivOnSubmit(_this.props, onSubmit) && _instanceof(target, Element) && target.getAttribute('type') === 'submit') {
                onSubmit(event);
            }
        };
        _this.renderSections = function(param) {
            var children = param.children, isRtl = param.isRtl, stack = param.stack;
            return React.Children.map(children, function(element) {
                if (isFormSectionChild(element)) {
                    return React.cloneElement(element, {
                        isRtl: isRtl,
                        stack: stack
                    });
                }
                return element;
            });
        };
        _this.handleSubmit = function(event) {
            return event.preventDefault();
        };
        return _this;
    }
    var _proto = Form.prototype;
    _proto.render = function render() {
        if (this.props.element === 'div') {
            var _props = this.props, _accessibilityLabel = _props.accessibilityLabel, _element = _props.element, _isRtl = _props.isRtl, _stack = _props.stack, testID = _props.testID, forwardedRef = _props.forwardedRef, _onSubmit = _props.onSubmit, propDrop = _objectWithoutProperties(_props, [
                "accessibilityLabel",
                "element",
                "isRtl",
                "stack",
                "testID",
                "forwardedRef",
                "onSubmit"
            ]);
            return _jsx("div", _objectSpread({
                ref: forwardedRef,
                onKeyPress: this.watchEnterClick,
                onClick: this.watchSubmitClick
            }, propDrop, injectTestId(testID), {
                css: getContainerStyles(),
                "aria-label": this.props.accessibilityLabel,
                children: this.renderSections(this.props)
            }));
        }
        var _props1 = this.props, _accessibilityLabel1 = _props1.accessibilityLabel, _element1 = _props1.element, _isRtl1 = _props1.isRtl, _stack1 = _props1.stack, testID1 = _props1.testID, forwardedRef1 = _props1.forwardedRef, propDrop1 = _objectWithoutProperties(_props1, [
            "accessibilityLabel",
            "element",
            "isRtl",
            "stack",
            "testID",
            "forwardedRef"
        ]);
        return _jsx("form", _objectSpread({
            ref: forwardedRef1,
            onSubmit: this.handleSubmit
        }, propDrop1, injectTestId(testID1), {
            css: getContainerStyles(),
            "aria-label": this.props.accessibilityLabel,
            children: this.renderSections(this.props)
        }));
    };
    return Form;
}(_Component = React.Component);
Form.defaultProps = {
    element: 'form'
};
Form.Section = FormSection;
function getContainerStyles() {
    return {
        width: '100%',
        position: 'relative'
    };
}
export default Form;
